import Loading from 'components/commons/loading/Loading';
import React from 'react';

export const TargetListLoading = (): React.ReactElement => {
  return (
    <>
      <Loading loading style={{ marginTop: '2rem' }} />
    </>
  );
};
